import { useState } from 'react';
import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: 'Navegação',
    links: [
      { label: 'Início', href: '/' },
      { label: 'Guia CSSBuy', href: '/guia-cssbuy-sheet/' },
      { label: 'Categorias', href: '#categorias' },
      { label: 'FAQ', href: '#faq' },
    ],
  },
  {
    title: 'Categorias',
    links: [
      { label: 'Shoes', href: 'https://kaspreadsheet.com/category-911-Shoes.html', external: true },
      { label: 'Hoodies/Sweaters', href: 'https://kaspreadsheet.com/search-912/name/Shoes.html', external: true },
      { label: 'T-Shirts', href: 'https://kaspreadsheet.com/search-913/name/Shoes.html', external: true },
      { label: 'Jackets', href: 'https://kaspreadsheet.com/search-914/name/Shoes.html', external: true },
    ],
  },
  {
    title: 'Links Úteis',
    links: [
      { label: 'Kaspreadsheet', href: 'https://kaspreadsheet.com', external: true },
      { label: 'Comparação', href: '#comparacao' },
      { label: 'Segurança', href: '#seguranca' },
      { label: 'Reviews', href: '#reviews' },
    ],
  },
  {
    title: 'Contato',
    links: [
      { label: 'Suporte', href: 'https://kaspreadsheet.com', external: true },
      { label: 'Privacidade', href: '/', external: false },
      { label: 'Termos', href: '/', external: false },
    ],
  },
];

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.target as HTMLFormElement;
    const honeypot = (form.querySelector('input[name="website_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setSubmitted(true);
      return;
    }
    const formData = new URLSearchParams();
    formData.append('email', email);
    try {
      await fetch('https://readdy.ai/api/form/d8voe52181e9e92u8tu0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });
    } catch (_) {
      // silently handle
    }
    setSubmitted(true);
    setEmail('');
  };

  return (
    <footer className="bg-background-950 text-background-100">
      {/* World map pattern overlay */}
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 opacity-[0.03] pointer-events-none"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 600'%3E%3Cpath fill='none' stroke='%23ffffff' stroke-width='0.5' d='M200,100 Q300,50 400,100 T600,100 T800,100 T1000,100 M150,200 Q250,150 350,200 T550,200 T750,200 T950,200 M100,300 Q200,250 300,300 T500,300 T700,300 T900,300 M150,400 Q250,350 350,400 T550,400 T750,400 T950,400 M200,500 Q300,450 400,500 T600,500 T800,500 T1000,500'/%3E%3C/svg%3E")`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        ></div>

        <div className="relative px-6 md:px-10 py-16 md:py-20">
          <div className="max-w-[1280px] mx-auto">
            {/* Top section */}
            <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
              {/* Brand + Newsletter */}
              <div className="lg:w-[380px] flex-shrink-0">
                <Link to="/" className="inline-flex items-center gap-2 mb-5">
                  <span className="font-heading text-2xl font-bold text-background-50">
                    CSSBuySpreadsheet
                    <span className="text-accent-500 ml-0.5">.</span>
                  </span>
                </Link>
                <p className="text-sm text-background-300/70 leading-relaxed mb-6">
                  A maior biblioteca de CSSBuy Spreadsheet em português. Produtos atualizados, guias completos e comparações para você comprar com segurança.
                </p>

                {/* Newsletter */}
                <form
                  data-readdy-form
                  onSubmit={handleSubmit}
                  className="flex flex-col sm:flex-row gap-2"
                >
                  <input
                    type="text"
                    name="website_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                  />
                  <div className="flex-1 relative">
                    <input
                      type="email"
                      name="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Seu melhor e-mail"
                      required
                      className="w-full px-4 py-2.5 text-sm bg-transparent border border-background-700/50 rounded-lg text-background-100 placeholder:text-background-500 focus:outline-none focus:border-accent-500/60 transition-colors"
                    />
                  </div>
                  <button
                    type="submit"
                    className="px-5 py-2.5 text-sm font-medium bg-accent-500 text-background-50 rounded-lg hover:bg-accent-600 transition-colors whitespace-nowrap flex items-center gap-2"
                  >
                    {submitted ? (
                      <>
                        <i className="ri-check-line"></i>
                        Inscrito
                      </>
                    ) : (
                      <>
                        <i className="ri-mail-send-line"></i>
                        Inscrever
                      </>
                    )}
                  </button>
                </form>
                {submitted && (
                  <p className="text-xs text-accent-400 mt-2">Obrigado! Você receberá nossas atualizações.</p>
                )}
              </div>

              {/* Link columns */}
              <div className="flex-1 grid grid-cols-2 md:grid-cols-4 gap-8">
                {footerLinks.map((col) => (
                  <div key={col.title}>
                    <h4 className="text-xs font-semibold uppercase tracking-wider text-background-400 mb-4">
                      {col.title}
                    </h4>
                    <ul className="space-y-2.5">
                      {col.links.map((link) => (
                        <li key={link.label}>
                          {link.external ? (
                            <a
                              href={link.href}
                              target="_blank"
                              rel="noopener nofollow"
                              className="text-sm text-background-300/60 hover:text-accent-400 transition-colors"
                            >
                              {link.label}
                            </a>
                          ) : (
                            <Link
                              to={link.href}
                              className="text-sm text-background-300/60 hover:text-accent-400 transition-colors"
                            >
                              {link.label}
                            </Link>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>

            {/* Bottom bar */}
            <div className="mt-14 pt-8 border-t border-background-800/40 flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-background-500">
                &copy; {new Date().getFullYear()} CSSBuySpreadsheet. Todos os direitos reservados.
              </p>
              <div className="flex items-center gap-3">
                {[
                  { icon: 'ri-instagram-line', href: 'https://kaspreadsheet.com' },
                  { icon: 'ri-twitter-x-line', href: 'https://kaspreadsheet.com' },
                  { icon: 'ri-youtube-line', href: 'https://kaspreadsheet.com' },
                  { icon: 'ri-discord-line', href: 'https://kaspreadsheet.com' },
                ].map((social) => (
                  <a
                    key={social.icon}
                    href={social.href}
                    target="_blank"
                    rel="noopener nofollow"
                    className="w-8 h-8 flex items-center justify-center rounded-lg border border-background-700/40 text-background-400 hover:text-accent-400 hover:border-accent-500/40 transition-colors"
                  >
                    <i className={`${social.icon} text-sm`}></i>
                  </a>
                ))}
              </div>
              <Link
                to="/"
                className="text-xs text-background-500 hover:text-accent-400 transition-colors"
              >
                Política de Privacidade
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}